<template>
  <!-- ケアオーケストレータークライアント証明書 -->
  <div id="ExternalClientCertificate">
      <div class="labelTitle lable">ケア オーケストレーター　クライアント証明書</div>
      <div id="item-contens">
        <div class="card-content margin-top">
          <template>
            <template v-if="downloadExpirationDate">
              <table>
                <tr><th>ダウンロード有効期限</th>
                  <td v-if="isExpirationDate()" style="color:red">
                    {{downloadExpirationDate}}
                  </td>
                  <td v-else>
                    {{downloadExpirationDate}}
                  </td>
                </tr>
                <tr><th>証明書有効期限</th><td>{{expirationDate}}</td></tr>
                <template v-if="isExpirationDate()">
                  <tr><th style="vertical-align: top;">クライアント証明書</th>
                    <td>
                      <div v-if="isExpirationDate()">
                        <b-button class="is-primary" style="width:400px" icon-left="content-duplicate" v-on:click="reapplication">証明書の再申請</b-button>
                        <p style="margin-top: 10px;margin-bottom: 10px;">証明書のダウンロード期限が切れました。証明書の再申請をお願いします。</p>
                      </div>
                    </td>
                  </tr>
                </template>
                <template v-else>
                  <tr>
                    <th>パスワード</th>
                      <td>
                        <div>
                          <span>{{password}}</span>
                          <b-button style="margin-left: 20px; width: 120px;height: 30px;" icon-left="clipboard-multiple-outline" v-on:click="passwordToClipboard">コピーする</b-button>
                        </div>
                      </td>
                  </tr>
                  <tr><th style="vertical-align: top;">クライアント証明書</th>
                    <td>
                      <div>
                        <a><b-button class="is-primary" style="width:400px" icon-left="cloud-download" v-on:click="download">証明書のダウンロード</b-button></a>    
                        <p style="margin-top: 10px;font-size: 90%;">証明書のダウンロードが完了しましたら、お使いの端末に証明書をインポートしてください。<br>
                                                    ※証明書をインポートしていない端末からはケア　オーケストレーターへのアクセスができません。</p>
                        <p style="margin-top: 10px;margin-bottom: 10px;">クライアント証明書をデバイスにインポートする手順は<a style="text-decoration: underline;" @click="downloadManual('ケア　オーケストレーターのクライアント証明書インポート方法.pdf')">こちら</a></p>
                      </div>
                    </td>
                  </tr>
                </template>
              </table>
            </template>
            <template v-else>
              <div v-if="!doSearchWaitFlg">
                証明書情報はありません。
              </div>
            </template>
          </template>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExternalClientCertificate",
  methods: {
    download: function(){
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.externalCOSetting.getDownloadCertificateFilePOST({
            body:{
              careOrchestratorInstitutionId:_this.careOrchestratorInstitutionId
            }
          });
        },
        function(result){
          if(result != null && result.status == 200){
            var downloadUrl = result.obj.downloadUrl;
            const a = document.createElement("a");
            document.body.appendChild(a);
            a.href = downloadUrl;
            a.click();
            a.remove();
          } else if(result != null){
            _this.showErrorMessage(result.message);
          } else {
            _this.showErrorMessage("予期しないエラーが発生しました。");
          }
        },
        function(error){
          // エラーメッセージ表示
          _this.showErrorMessage(error);
        }
      );
    },
    downloadManual: function(){
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.externalCOSetting.getDownloadCertificateManualPOST({
            body:{
            }
          });
        },
        function(result){
          if(result != null && result.status == 200){
            var downloadUrl = result.obj.downloadUrl;
            const a = document.createElement("a");
            document.body.appendChild(a);
            a.href = downloadUrl;
            a.target="_blank"
            a.click();
            a.remove();
          } else if(result != null){
            _this.showErrorMessage(result.message);
          } else {
            _this.showErrorMessage("予期しないエラーが発生しました。");
          }
        },
        function(error){
          // エラーメッセージ表示
          _this.showErrorMessage(error);
        }
      );
    },
    doSearch: function() {
      var executeApi = this.getCoCertificateInfoPOST;
      var successCallBack = this.getCoCertificateInfoPOSTSuccess;
      var errorCallBack = this.getCoCertificateInfoPOSTError;
      // Web Api Call
      this.apiCall(executeApi, successCallBack, errorCallBack);
    },
    getCoCertificateInfoPOST: function(client) {
      return client.apis.externalCOSetting.getCoCertificateInfoPOST({
        body:{
          careOrchestratorInstitutionId:this.careOrchestratorInstitutionId,
        }
      });
    },
    getCoCertificateInfoPOSTSuccess: function(result) {
      // 検索結果取得
      this.downloadExpirationDate = result.obj.downloadExpirationDate ? result.obj.downloadExpirationDate : "";
      this.expirationDate = result.obj.expirationDate ? result.obj.expirationDate : "";
      this.password = result.obj.password ? result.obj.password : "";
      this.doSearchWaitFlg = false;
    },
    getCoCertificateInfoPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      this.doSearchWaitFlg = false;
    },
    reapplication: function() {
      var executeApi = this.updateReUploadCertificatePOST;
      var successCallBack = this.updateReUploadCertificatePOSTSuccess;
      var errorCallBack = this.updateReUploadCertificatePOSTError;
      // Web Api Call
      this.apiCall(executeApi, successCallBack, errorCallBack);
    },
    updateReUploadCertificatePOST: function(client) {
      return client.apis.externalCOSetting.updateReUploadCertificatePOST({
        body:{
          careOrchestratorInstitutionId:this.careOrchestratorInstitutionId,
        }
      });
    },
    updateReUploadCertificatePOSTSuccess: function(result) {
      //update文のコールバック
      this.showErrorMessage("クライアント証明書の再申請を行いました。\nシステムへの設定が完了しましたら、登録済みメールアドレスに設定完了メールが送付されます。");
      
    },
    updateReUploadCertificatePOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    isExpirationDate: function(){
      let expirationDate = new Date(this.downloadExpirationDate + " 23:59:59").getTime();
      let nowDate = new Date().getTime();
      return expirationDate < nowDate;
    },
    passwordToClipboard: function(){
      navigator.clipboard.writeText(this.password).then(() => {
        this.showMessage('クリップボードにコピーしました。');
      }).catch(err => {
        this.showMessage('コピーに失敗しました');
        console.log(err);
      });
    }
  },
  data() {
    let careOrchestratorInstitutionId = this.$route.params["careOrchestratorInstitutionId"];
    return {
      careOrchestratorInstitutionId:careOrchestratorInstitutionId,
      downloadExpirationDate:"",
      expirationDate:"",
      password:"",
      doSearchWaitFlg: true
    };
  },
  filters: {},
  components: {
  },
  mounted:async function() {
    await this.doSearch()
  }
};
</script>


// WEBPACK FOOTER //
// src/components/mock/guest/careorchestrator/setting/ExternalClientCertificate.vue